import dayjs from 'dayjs';

export const mapLinksEncuestasToTable = (links: any[]) => {
  if (!links || !Array.isArray(links)) return [];

  return links.map((link) => ({
    id: link.id,
    name: link.name || '',
    description: link.description || '',
    token: link.token || '',
    status: link.status === 1 ? 'Activo' : 'Inactivo',
    responseAt: link.responseAt
      ? dayjs(link.responseAt).format('YYYY-MM-DD HH:mm')
      : 'Sin contestar',
    createdAt: link.createdAt ? dayjs(link.createdAt).format('YYYY-MM-DD HH:mm') : '',
    survey: link.survey || null,
    user: link.user || null,
    fechaEvento: link.eventDate || null,
    nombreEvento: link.eventName || null,
    nombreCliente: link.clientName || null,
    telefonoCliente: link.clientPhone || null,
    emailCliente: link.clientEmail || null,
    diaNacimiento: link.birthDay || null,
    mesNacimiento: link.birthMonth || null,
    shareTemplate: link.shareTemplate || null,
    shareMessage: link.shareMessage || null,
  }));
};

export const mapLinkEncuestaFormToApi = (formData: any, authUser?: any) => {
  return {
    name: formData.name,
    description: formData.description,
    surveyId: formData.surveyId?.value || null,
    userId: formData.userId?.value || null,
    eventDate: formData.fechaEvento || null,
    eventName: formData.nombreEvento || null,
    clientName: formData.nombreCliente || null,
    clientPhone: formData.telefonoCliente || null,
    clientEmail: formData.emailCliente || null,
    birthDay: formData.diaNacimiento ? parseInt(formData.diaNacimiento, 10) : null,
    birthMonth: formData.mesNacimiento ? parseInt(formData.mesNacimiento, 10) : null,
    shareTemplate: formData.shareTemplate?.value || null,
  };
};
